import {
  ARTICLE_REPORT_CATEGORY_LABELS,
  ARTICLE_REPORT_STATUS_LABELS,
  type ArticleReportType,
} from '@/defs/articleReport'
import { isNonEmptyString } from '@/utils/commonUtil'

import { ArticleReportStatus } from '../ArticleReportStatus/ArticleReportStatus'

import styles from './ArticleReportModal.module.scss'

type Props = {
  reports: ArticleReportType[]
}

export const ArticleReportModal = ({ reports }: Props) => (
  <div className={styles.container}>
    <h2 className={styles.title}>Preview Report</h2>
    <section className={styles.section}>
      {!reports.length ? (
        <p className={styles.empty}>No reports to display.</p>
      ) : (
        <ul className={styles.list}>
          {reports.map(({ category, message, status, subject }, i) => {
            const { label: labelCategory } = ARTICLE_REPORT_CATEGORY_LABELS[category]
            const { label: labelStatus } = ARTICLE_REPORT_STATUS_LABELS[status]

            return (
              <li className={styles.item} key={i}>
                <ArticleReportStatus status={status} />
                <span className={styles.itemBody}>
                  <span className={styles.itemHeading}>{subject ? `${labelCategory}: ${subject}` : labelCategory}</span>
                  <span className={styles.itemDetails}>
                    {[labelStatus, message].filter(isNonEmptyString).join(' - ')}
                  </span>
                </span>
              </li>
            )
          })}
        </ul>
      )}
    </section>
  </div>
)
